var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarOfDavid1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 10.4883L7.29236 9.25H8.70759L7.99998 10.4883Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4352 9.25L8.86377 12L10.4352 14.75H13.5648L15.1362 12L13.5648 9.25H10.4352Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29236 14.75L7.99998 13.5117L8.70759 14.75H7.29236Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.4883L11.2924 16.25H12.7076L12 17.4883Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7076 14.75H15.2924L16 13.5117L16.7076 14.75Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7076 9.25L16 10.4883L15.2924 9.25H16.7076Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.51166L11.2924 7.74999H12.7076L12 6.51166Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12.6512 4.6279L14.4352 7.75H18C18.2674 7.75 18.5145 7.89232 18.6487 8.12356C18.7829 8.35479 18.7838 8.63998 18.6512 8.8721L16.8638 12L18.6512 15.1279C18.7838 15.36 18.7829 15.6452 18.6487 15.8764C18.5145 16.1077 18.2674 16.25 18 16.25H14.4352L12.6512 19.3721C12.5176 19.6058 12.2691 19.75 12 19.75C11.7309 19.75 11.4823 19.6058 11.3488 19.3721L9.56476 16.25H6C5.73265 16.25 5.48551 16.1077 5.35132 15.8764C5.21713 15.6452 5.21617 15.36 5.34882 15.1279L7.13619 12L5.34882 8.8721C5.21617 8.63998 5.21713 8.35479 5.35132 8.12355C5.48551 7.89232 5.73265 7.75 6 7.75H9.56476L11.3488 4.6279C11.4823 4.39421 11.7309 4.25 12 4.25C12.2691 4.25 12.5176 4.39421 12.6512 4.6279Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOfDavid1);
export default __webpack_public_path__ + "static/media/star-of-david-1.0d9d7f1893c1eb88812457a23b52bcdc.svg";
export { ForwardRef as ReactComponent };